import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CommonLayout from "../../layouts/CommonLayout";
import { reportInMeeting } from '../../../api/ReportApi';
import { AlertModal } from '../../layouts/AlertModal'; // AlertModal import

const ReportInMeetingPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { meetingId } = useParams();
    const { reportedId } = location.state || {};

    const [content, setContent] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // 모달 상태 관리 (title 제거)
    const [alertState, setAlertState] = useState({ isVisible: false, message: '', callback: null });

    const getErrorMessage = (error) => {
        if (error.response && error.response.data && error.response.data.message) {
            return error.response.data.message;
        }
        return '오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!content.trim()) {
            setAlertState({ isVisible: true, message: '신고 내용을 입력해주세요.' });
            return;
        }

        try {
            setIsSubmitting(true);
            await reportInMeeting(reportedId, meetingId, content);
            setAlertState({
                isVisible: true,
                message: '신고가 접수되었습니다.',
                callback: () => navigate(-1)
            });
        } catch (error) {
            console.error('신고 처리 중 오류가 발생했습니다:', error);
            setAlertState({ isVisible: true, message: getErrorMessage(error) });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleContentChange = (e) => {
        const text = e.target.value;
        if (text.length <= 300) {
            setContent(text);
        }
    };

    return (
        <CommonLayout title="신고하기">
            <AlertModal
                isVisible={alertState.isVisible}
                message={alertState.message}
                callback={alertState.callback}
                onClose={() => setAlertState({ isVisible: false, message: '', callback: null })}
            />
            <div className="p-4">
                <h1 className="text-xl font-bold mb-4">해당 밥친구가 부적절한 언행을 했다면 신고해주세요</h1>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="relative">
                        <textarea
                            value={content}
                            onChange={handleContentChange}
                            placeholder="신고 내용을 입력해주세요."
                            className="w-full p-3 border border-gray-300 rounded-md resize-none h-40"
                            disabled={isSubmitting}
                        />
                        <div className="absolute bottom-2 right-2 text-sm text-gray-500">
                            {content.length}/300자
                        </div>
                    </div>

                    <div className="p-4 bg-gray-100 rounded-md">
                        <ul className="list-disc pl-5 text-black text-sm">
                            <li>신고 내용은 운영자의 검토 및 처리 후 대응한 내용을 24시간 내 알림으로 보내드립니다.</li>
                            <li>신고 시 운영자가 관련된 채팅 내용을 확인할 수 있습니다.</li>
                            <li>내부 규정에 따라 신고 내용이 반려될 수 있으며, 허위 신고 시 서비스 이용에 제한을 받을 수 있습니다.</li>
                            <li>해당 밥친구가 모임장이 아닐 경우, 모임의 과반수 이상의 멤버가 해당 밥친구를 신고하면 해당 밥친구는 모임에서 추방됩니다.</li>
                        </ul>
                    </div>

                    <button
                        type="submit"
                        className="w-full px-4 py-3 bg-amber-500 text-white rounded-md active:bg-amber-600 disabled:bg-gray-400 disabled:cursor-not-allowed"
                        disabled={isSubmitting || !content.trim()}
                    >
                        {isSubmitting ? '처리중...' : '신고하기'}
                    </button>
                </form>
            </div>
        </CommonLayout>
    );
};

export default ReportInMeetingPage;
